import { LocalStorageKeyType } from 'models';

export function saveToLocalStorage(key: LocalStorageKeyType, value?: unknown) {
	localStorage.setItem(key as string, JSON.stringify(value));
}
